import { Capacitor } from '@capacitor/core';
import { AppleSignIn, SignInScope } from '@capawesome/capacitor-apple-sign-in';
import { ErrorCode, GoogleSignIn } from '@capawesome/capacitor-google-sign-in';

export const NATIVE_LOGIN_CANCELLED_CODE = ErrorCode.SignInCanceled;

export async function getNativeProviderData(provider: string, googleWebClientId: string) {
    if (provider === 'google_oauth2') {
        await GoogleSignIn.initialize({ clientId: googleWebClientId });
        return GoogleSignIn.signIn();
    }

    // The sign-in forms hide Apple on Android. The plugin's Android flow is a WebView OAuth flow that needs AppleSignIn.initialize.
    if (provider === 'apple_quantic' && Capacitor.getPlatform() === 'ios') {
        const { user, email, givenName, familyName, idToken } = await AppleSignIn.signIn({
            scopes: [SignInScope.Email, SignInScope.FullName],
        });

        // Auth::NativeOauthExchangesController#apple_quantic reads the shape of the old Cordova plugin's response.
        return { user, email, fullName: { givenName, familyName }, identityToken: idToken };
    }

    throw new Error('Unsupported native provider');
}

export async function signOutOfNativeGoogle(webClientId: string) {
    await GoogleSignIn.initialize({ clientId: webClientId });
    await GoogleSignIn.signOut();
}
